import { render, staticRenderFns } from "./MenuDialogCalendar.vue?vue&type=template&id=05dac441"
import script from "./MenuDialogCalendar.vue?vue&type=script&lang=js"
export * from "./MenuDialogCalendar.vue?vue&type=script&lang=js"
import style0 from "./MenuDialogCalendar.vue?vue&type=style&index=0&id=05dac441&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports